import React, { useState, useRef, useEffect } from "react";
import { AgCharts } from "ag-charts-react";
import { Box, Container, Paper, Stack, Toolbar, Typography } from "@mui/material";

import ToggleSet from "../Components/ToggleSet.jsx";
import LabelInput from "./setLabel.jsx";
import { API_Client, APIs_SweepData } from "./api.jsx";
import { useWindowDimensions } from "./useWindowDimensions.jsx";
import { chartTooltipRendererMoney, chartTooltipRendererPercent } from "./Chart_tooltip.jsx";

import { CrumbToggleScenario } from "../Components/CrumbToggles.jsx";
import { FtchPlusError, SweepUrl, ftchPlus, getOptions, putOptions } from "./Account_urls.jsx";
import { ErrorBar } from "../Components/ErrorBar.jsx";
import { HelpChartSweep } from "../Dialogs/Help/Help_Charts.jsx";
import { myOwnFP_chart_palette2 } from "../Components/Charts.jsx";
import dayjs from "dayjs";
import { ChartExport } from "../Components/ChartExport.jsx";
import GridChartViewPort from "../Dialogs/GridChart/GridChartViewPort.jsx";
import { GridCsv } from "../Components/GridCsv.jsx";
import { ChartIcon, GridChartIcon } from "../Dialogs/GridChart/GridChartIcon.jsx";
import HelpIcon from "../Dialogs/Help/HelpIcon.jsx";

const ChartAxesFormatPercent = ({ value }) => {
  return "" + value + "%"
}
const ChartAxesFormatMoney = ({ value }) => {
  return Intl.NumberFormat('en-CA', {
    style: "currency",
    currency: "CAD",
    notation: "compact",
    compactDisplay: "short"
  }).format(value);
}
export const UpdateAxes = (axes) => {
  if (axes === undefined || axes === null) {
    return {
      money:
      {
        type: 'number',
        position: 'left',
        label: {
          format: '#{ >-$,.2s}',
        },
      },
      x:
      {
        type: 'category',
        position: 'bottom',
      },
    }
  } else {
    // console.log(axes)
    for (const [key] of Object.entries(axes)) {
      // console.log(key)
      // console.log(axes[key])
      if (axes[key].label.formatter) {
        if (axes[key].label.formatter === "money") {
          axes[key].label.formatter = ChartAxesFormatMoney
        } else if (axes[key].label.formatter === "percent") {
          axes[key].label.formatter = ChartAxesFormatPercent
        }
      }
    }
  }
  //console.log(axes)
  return axes
}

export const UpdateSeries = (series) => {
  if (series) {
    let x = [];
    if (series) {
      for (let i = 0; i < series.length; i++) {
        let p = series[i];
        if (p.yKeyAxis === "money") {
          p.tooltip = { renderer: chartTooltipRendererMoney };
        } else if (p.yKeyAxis === "percent") {
          p.tooltip = { renderer: chartTooltipRendererPercent };
        }
        x.push(p);
      }
    }
    return x;
  }
  return;
};

const Chart = ({ clientJson, c_callback, uuid }) => {
  const { winHeight, winWidth } = useWindowDimensions();
  const chartRef = useRef(null);
  const gridRef = useRef(null);


  const [errmsg, setErrmsg] = useState("")

  const clientData = useRef(null);
  const [clients, setClients] = useState([]);
  const [client, setClient] = useState();
  const [dataSets, setDataSets] = useState([]);
  const [dataSet, setDataSet] = useState();

  const [chartTitle, setChartTitle] = useState();
  const [chartOptions, setChartOptions] = useState({})
  const [whoWhen, setWhoWhen] = useState("");
  const [changed, setChanged] = useState(false)
  const [gridShow, setGridShow] = useState(false)

  const [form, setForm] = useState({
    Label: "",
    Description: ""
  });

  const onGridIconClick = (v) => {
    setGridShow(v)
  }


  const getTitle = () => {
    return chartTitle;
  };


  const setOptions = (ti, st, d, a, s) => {
    setChartOptions({
      title: ti,
      subtitle: st,
      axes: a,
      data: d,
      series: s,
      theme: {
        palette: myOwnFP_chart_palette2,
      },
      tooltip: {
        mode: "single",
      },
      height: winHeight - 50 * 4,
      width: winWidth - 10 * 4,
      legend: { position: "bottom" },
    })
  }





  const Update = (cl, ds) => {
    if (clientData.current && clientData.current[cl] && clientData.current[cl][ds]) {
      setChartTitle(clientData.current[cl][ds].Title);
      let ca = UpdateAxes(clientData.current[cl][ds].Axes);
      if (ca) {
        let cs = UpdateSeries(clientData.current[cl][ds].Series)
        setOptions(clientData.current[cl][ds].Title,
          { "text": scenName() + " : " + cl + " : " + ds },
          clientData.current[cl][ds].Data,
          ca,
          cs)

      } else {
        setOptions(clientData.current[cl][ds].Title,
          { "text": scenName() + " : " + cl + " : " + ds },
          clientData.current[cl][ds].Data,
          {},
          clientData.current[cl][ds].Series)
      }

    } else {
      setOptions({ text: "" },
        { text: "" },
        [],
        {},
        [])
    }
  };

  const putLabel = async () => {
    var url = SweepUrl(clientJson, "info", "");
    console.log(url);
    var req = putOptions;
    req.body = JSON.stringify(form);
    ftchPlus(url, req)
      .then((response) => {
        console.log(response.Uuid);
        let scen = {
          ...clientJson.Sweep,
          label: form.Label,
        };
        let json = { ...clientJson, Scenario: scen };
        c_callback(json);
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
        FtchPlusError(error)
      });
  };


  const getData = async () => {
    if (uuid) {
      var url = API_Client + clientJson.uuid + APIs_SweepData + uuid;
      ftchPlus(url, getOptions)
        .then((json) => {
          console.log(json);

          // store data first
          clientData.current = json.ClientData;
          console.log(json.ClientData);

          setClients(json.Clients);
          setDataSets(json.DataSets);
          const cl = json.Clients[0];
          const ds = json.DataSets[0];
          setClient(cl);
          setDataSet(ds);
          setForm({
            ...form,
            Label: json.Info.Label,
            Description: json.Info.Description,
          });
          let d = new dayjs(json.Info.Executed.When);
          setWhoWhen(
            "(" +
            json.Info.Executed.Who +
            " @ " +
            d.format("D-MMM-YYYY") +
            "  " +
            d.format("H:mm") +
            ")"
          );
          Update(cl, ds);
        })
        .catch((error) => {
          console.log(error.message);
          setErrmsg(error.message)
          FtchPlusError(error)
        });
    }
  };

  //  load data from sever
  useEffect(() => {
    setErrmsg("")
    setChanged(false)
    getData();
  }, [uuid]);

  const onStoreInfo = (value, description) => {
    setForm({ ...form, Label: value, Description: description });
    setChanged(true)
  };
  const onSave = () => {
    putLabel();
    setChanged(false)
  };

  const btnClientChanged = (value) => {
    setClient(value);
    Update(value, dataSet);
  };

  const btnDataSetChanged = (value) => {
    setDataSet(value);
    Update(client, value);
  };

  const getHeight = () => {
    return winHeight - 50 * 4;
  };

  const chartRefFn = () => {
    return chartRef
  }

  const scenName = () => {
    return (clientJson.Scenario.label)
  }

  const getFileName = () => {
    if (chartTitle) {
      return "MyOwnFP " + scenName() + " " + client + " " + dataSet + " " + chartTitle.text
    }
    return "export"
  }

  const gridRefFn = () => {
    return gridRef
  }


  return (
    <Container maxWidth="false"  >
      <Stack spacing={2}>
        <Toolbar>
          <Box sx={{ display: "flex", flexGrow: 1 }}>
            <Stack direction="row" spacing={2}>
              <CrumbToggleScenario
                clientJson={clientJson}
                set={clients}
                current={client}
                onChange={btnClientChanged}
              />
              <ToggleSet
                set={dataSets}
                current={dataSet}
                onChange={btnDataSetChanged}
              />
              <div>
                <LabelInput
                  label={form.Label}
                  description={form.Description}
                  onChange={onStoreInfo}
                  onSave={onSave}
                  disabled={!changed}
                />
              </div>
            </Stack>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              alignContent: "center",
              justifyContent: "flex-end",
            }}>
            <Stack direction="row" spacing={4}>

              {!gridShow && (
                <>
                  <GridChartIcon
                    onClick={(v) => onGridIconClick(true)}
                  />

                  <ChartExport
                    filename={getFileName()}
                    titleFn={getTitle}
                    chartRefFn={chartRefFn}
                  />
                </>
              )}
              {gridShow && dataSet !== "" && chartTitle && (
                <>
                  <ChartIcon
                    onClick={(v) => onGridIconClick(false)}
                  />

                  <GridCsv
                    filename={getFileName()}
                    name={chartTitle.text}
                    scenario={scenName()}
                    client={client}
                    dataset={dataSet}
                    gridRefFn={gridRefFn}
                  />
                </>
              )}
              <HelpIcon mt={-1} />
            </Stack>
          </Box>

        </Toolbar>

        <Paper >

          {gridShow ? (
            <GridChartViewPort
              show={gridShow}
              clientData={clientData.current}
              client_={client}
              dataSet_={dataSet}
              height={getHeight()}
              gridRef={gridRef}
            />
          ) : (
            <Stack sx={{ pb: 5 }}>
              <AgCharts
                ref={chartRef}
                options={chartOptions}
              />
              <ErrorBar error={errmsg} />
              <HelpChartSweep />
              <Typography id="1" variant="body2">
                {whoWhen}
              </Typography>
            </Stack>

          )}
        </Paper>

      </Stack >

    </Container >
  );
};

export default Chart;
